<template>
    <div class="form-view">
        <section>
            <h2 v-if="newUser" class="text-center">Tilføj medarbejder</h2>
            <h2 v-else class="text-center">Rediger medarbejder</h2>
            <div v-if="!existingUser" style="position: absolute; right: 93px; top: 20px; width: 135px;">
                <switches v-model="enabled" theme="custom" type-bold="false" color="blue" />
                <span v-if="enabled" style="color:">Aktiv</span><span v-else>Inaktiv</span>
            </div>
            <div v-if="!existingUser" class="tabs tabs-style-linemove tabs-modal">
                <nav style="margin-top: 20px;">
                    <ul>
                        <li :class="{'tab-current': selectedTab === 1}">
                            <a @click="changeTab(1)">
                                <span>Oplysninger</span>
                            </a>
                        </li>
                        <li :class="{'tab-current': selectedTab === 2}">
                            <a @click="changeTab(2)">
                                <span>Roller & rettigheder</span>
                            </a>
                        </li>
                        <li :class="{'tab-current': selectedTab === 3}">
                            <a @click="changeTab(3)">
                                <span>Gruppe</span>
                            </a>
                        </li>
                        <li :class="{'tab-current': selectedTab === 4}">
                            <a @click="changeTab(4)">
                                <span>Anlæg</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <section v-show="selectedTab === 1">
                <div v-if="!existingUser">
                    <user-info @validate="validateFields()"></user-info>
                </div>
                <div v-else-if="existingUser && !checkingUserFeedback" class="user-existing-info-container">
                    <div class="grid-x flexbox-justify-content-center cell user-existing-info-header">
                        <span>En bruger findes allerede med e-mail:</span>
                        <span>{{user.email}}</span>
                    </div>
                    <div class="grid-x">
                        <div class="cell user-existing-info">
                            <div class="grid-x user-existing-info-profile">
                                <icon class="huge-svg fill-primary" name="user" />
                            </div>
                            <div class="grid-x user-existing-info-name" style="font-weight: 500; margin-bottom: 35px; font-size: 1.1rem; text-align: center;">
                                <span>{{existingUser.name}}</span>
                            </div>
                            <div class="grid-x user-existing-info-text">
                                <icon class="small-svg fill-primary" name="phone" />
                                <span>{{existingUser.phoneNumber}}</span>
                            </div>
                            <div class="grid-x user-existing-info-text">
                                <icon class="small-svg fill-primary" name="envelope" />
                                <span>{{existingUser.email}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="grid-x" style="margin-top: 70px; display: flex; justify-content: center;">
                        <span>Du har mulighed for at tilknytte den eksisterende bruger til <span style="font-weight: 500; text-transform: uppercase;">{{application.value}}</span> eller oprette en ny bruger</span>
                    </div>
                </div>
            </section>
            <section v-show="selectedTab === 2">
               <div class="form">
                    <div class="border-bottom user-roles-rights">
                        <div class="grid-x">
                            <div class="cell auto" :class="{'user-role-selected': roleSelected.toLowerCase() === 'localadministrator'}" @click="roleSelected = 'localadministrator'">
                                <div class="grid-x">
                                    Administrator
                                </div>
                                <div class="grid-x">
                                    Rettigheder:
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    administration
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    henvendelser
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    opgaver
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    entreprenøropgaver
                                </div>
                                <transition name="fade">
                                    <div v-if="roleSelected.toLowerCase() === 'localadministrator'" class="checkmark-circle">
                                        <icon class="medium-svg fill-white" name="checkmark" />
                                    </div>
                                </transition>
                            </div>
                            <div class="cell auto" :class="{'user-role-selected': roleSelected.toLowerCase() === 'caseowner'}" @click="roleSelected = 'caseOwner'">
                                <div class="grid-x">
                                    Sagsbehandler
                                </div>
                                <div class="grid-x">
                                    Rettigheder:
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    henvendelser
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    opgaver
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    entreprenøropgaver
                                </div>
                                <transition name="fade">
                                    <div v-if="roleSelected.toLowerCase() === 'caseowner'" class="checkmark-circle">
                                        <icon class="medium-svg fill-white" name="checkmark" />
                                    </div>
                                </transition>
                            </div>
                            <div class="cell auto" :class="{'user-role-selected': roleSelected.toLowerCase() === 'contractor'}" @click="roleSelected = 'contractor'">
                                <div class="grid-x">
                                    Entreprenør
                                </div>
                                <div class="grid-x">
                                    Rettigheder:
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    entreprenøropgaver
                                </div>
                                <transition name="fade">
                                    <div v-if="roleSelected.toLowerCase() === 'contractor'" class="checkmark-circle">
                                        <icon class="medium-svg fill-white" name="checkmark" />
                                    </div>
                                </transition>
                            </div>
                            <div class="cell auto" :class="{'user-role-selected': roleSelected.toLowerCase() === 'frontdeskemployee'}" @click="roleSelected = 'frontDeskEmployee'">
                                <div class="grid-x">
                                    Frontmedarbejder
                                </div>
                                <div class="grid-x">
                                    Rettigheder:
                                </div>
                                <div class="grid-x user-roles-rights-bullets">
                                    <div>
                                        <icon class="tiny-svg fill-dark-gray" name="circle" />
                                    </div>
                                    henvendelser
                                </div>
                                <transition name="fade">
                                    <div v-if="roleSelected.toLowerCase() === 'frontdeskemployee'" class="checkmark-circle">
                                        <icon class="medium-svg fill-white" name="checkmark" />
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form supply-types-select-all-when-disabled" :class="{'disabled': roleSelected === 'contractor'}">
                    <supply-type :multiple="true" />
                </div>
                <div class="form">
                    <div class="grid-x" style="margin-top: 16px;">
                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                            <icon class="user small-svg fill-dark-gray" name="automated-process" />
                        </div>
                        <div class="large-5 cell flexbox-align-items">
                            <span>Afslut opgave ved færdigmelding</span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="automaticCloseTask" theme="custom" type-bold="false" color="blue" />
                        </div>
                    </div>
                </div>
                <div class="form">
                    <div class="grid-x">
                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                            <icon class="user small-svg fill-dark-gray" name="tags" />
                        </div>
                        <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items">
                            <p class="custom-modal-text-alignment">Tags</p>
                        </div>
                        <div class="auto cell border-bottom">
                            <multiselect v-model="selectedTags" :options="tagList" :multiple="true" placeholder="Vælg et eller flere tags" :close-on-select="false" :clear-on-select="false" :searchable="false" label="description" select-label="" deselect-label="" selected-label="" track-by="tagName" :preselect-first="false" />
                        </div>
                    </div>
                </div>
            </section>
            <section v-show="selectedTab === 3">
                <div class="form">
                    <div class="grid-x">
                        <div class="cell small-1 medium-1 large-1 flexbox-center">
                            <icon class="small-svg fill-dark-gray" name="group" />
                        </div>
                        <div class="cell small-3 medium-3 large-3 flexbox align-items">
                            <p class="custom-modal-text-alignment">Tilknyttede brugere</p>
                        </div>
                        <div class="cell auto">
                            <multiselect :options="userList" :multiple="true" trackBy="userId" label="name" :searchable="false" placeholder="Vælg en eller flere brugere" :closeOnSelect="false" v-model="selectedUsers" />
                        </div>
                    </div>
                    <div class="grid-x">
                        <div class="large-1 medium-1 small-1 cell flexbox-center"/>
                        <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items" />
                        <div class="auto cell border-bottom">
                            <p><small><em>Tilknyttede brugere modtager de samme notifikationer som denne bruger</em></small></p>
                        </div>
                    </div>
                </div>
            </section>
            <section v-show="selectedTab === 4">
                <div class="form">
                    <div class="grid-x list-sort">
                        <div class="cell small-6 item flexbox">Anlægs træ</div>
                        <div class="cell small-2 item flexbox">Adgang</div>
                        <div class="cell small-4 item flexbox">Rolle</div>
                    </div>
                    <div style="overflow: auto; max-height: 50vh;">
                        <div class="grid-x list-row align-items facility-tree" v-for="tree in facilityTrees" :key="tree.facilityTreeId">
                            <div class="cell small-6 item flexbox-align-items">
                                <span class="truncate-ellipse">{{ tree.facilityTreeName }}</span>
                            </div>
                            <div class="cell small-2 item">
                                <switches v-model="tree.selected" theme="custom" type-bold="false" color="blue" @input="toggleTree(tree)" style="padding-top: 12px;" />
                            </div>
                            <div class="cell small-4 item">
                                <template v-if="tree.selected">
                                    <div v-for="userGroup in tree.userGroups" :key="userGroup.facilityUserGroupId" style="display: grid; grid-template-columns: max-content 1fr; gap: 8px;">
                                        <input :id="`radio-${tree.facilityTreeId}-${userGroup.facilityUserGroupId}`" v-model="tree.selectedUserGroupId" :value="userGroup.facilityUserGroupId" type="radio" :name="tree.facilityTreeId"/>
                                        <label :for="`radio-${tree.facilityTreeId}-${userGroup.facilityUserGroupId}`">{{ userGroup.name }}</label>
                                    </div>
                                </template>
                                <div v-else><em>Brugeren har ikke adgang</em></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div v-if="!existingUser" class="text-center buttons-modal" style="position: unset;">
                <a :class="{'disabled': validateFields()}" @click="addUpdateUser()">
                    <span v-if="newUser">Tilføj</span>
                    <span v-else>Gem</span>
                </a>
                <a @click="closeModal()">Fortryd</a>
            </div>
            <div v-else class="text-center buttons-modal">
                <a @click="useExistingUser()">Brug eksisterende</a>
                <a @click="useNewUser()">Opret ny</a>
            </div>
            </section>
        </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Switches from 'vue-switches'
import supplyType from './../../../../components/shared/supplytype/supplytype'
import emailValidation from './../../../shared/email/email-validation.vue'
import userInfo from '../administration-modal-user-info'
import Multiselect from 'vue-multiselect'

export default {
    name: 'administration-modal-user-drive',
    components: {
        Switches,
        'supply-type': supplyType,
        'email-validation': emailValidation,
        'user-info': userInfo,
        Multiselect
    },
    data () {
        return {
            user: {
                username: null,
                name: null,
                password: null,
                password2: null,
                email: null,
                phoneNumber: null,
                note: null,
                organizationId: null,
                userId: null
            },
            automaticCloseTask: false,
            validEmail: true,
            enabled: true,
            selectedTab: 1,
            roleSelected: '',
            checkingUserFeedback: false,
            newUser: false,
            newExistingUser: false,
            currentUserRoles: [],
            selectedTags: null,
            permissionEditGisData: null,
            selectedUsers: null,
            facilityTrees: [],
            facilityGroups: []
        }
    },
    computed: {
        ...mapGetters({
            selectedMultipleSupplyType: 'getSelectedMultipleSupplyType',
            applicationGroupList: 'getApplicationGroupList',
            application: 'getApplication',
            existingUser: 'getUserExist',
            organizationEmployeeList: 'getOrganizationEmployeeList',
            selectedCompanies: 'getSelectedCompanies',
            employee: 'getEmployee',
            portalAppKey: 'getPortalAppKey',
            supplyTypes: 'getSysBusinessAreaTypeList',
            applicationSettings: 'getApplicationSettingsDrive',

            getAssociatedUsers: 'getAssociatedUsers',
            getUserFacilityGroups: 'getUserFacilityGroups',
            userInfo: 'userInfo'
        }),

        tagList () {
            if (this.applicationSettings && this.applicationSettings.length > 0) {
                const lookups = this.applicationSettings.find((a) => a.category === 'lookups')
                if (lookups) {
                    return lookups.value.tagList.filter((t) => t.worksOnUser === true)
                }
                return []
            }
            return []
        },
        userList () {
            return this.organizationEmployeeList.filter(employee => employee.userId !== this.employee.userId && employee.activeInOrganization)
        }
    },
    methods: {
        ...mapActions({
            setCreateUser: 'setCreateUser',
            setUpdateUser: 'setUpdateUser',
            setNonSelectedMultipleSupplyType: 'setNonSelectedMultipleSupplyType',
            setClearUserExist: 'setClearUserExist',
            setSelectedMultipleSupplyTypeFromId: 'setSelectedMultipleSupplyTypeFromId',
            setEmployee: 'setEmployee',
            setApplicationSettingsDrive: 'setApplicationSettingsDrive',
            removeUserFromFacilityUserGroup: 'removeUserFromFacilityUserGroup',
            addUserToFacilityUserGroup: 'addUserToFacilityUserGroup',

            setAssociatedUsers: 'setAssociatedUsers',
            updateAssociatedUsers: 'updateAssociatedUsers',
            setUserFacilityGroups: 'setUserFacilityGroups',
            setFacilityGroups: 'setFacilityGroups'
        }),
        useExistingUser () {
            this.newExistingUser = true
            this.setEmployee(this.existingUser)
            this.setClearUserExist()
        },
        useNewUser () {
            this.setEmployee('')
            this.setClearUserExist()
        },
        closeModal () {
            this.setNonSelectedMultipleSupplyType()
            this.$emit('close')
        },
        validateFields () {
            if (!this.employee.name || !this.employee.email || !this.validEmail) {
                return true
            }
            if (this.checkingUserFeedback || (this.roleSelected.toLowerCase() !== 'contractor' && (this.selectedMultipleSupplyType && this.selectedMultipleSupplyType.length < 1)) || !this.roleSelected) {
                return true
            } else {
                return false
            }
        },
        addUpdateUser () {
            let user = {
                info: null,
                active: null,
                roles: [],
                rolesToRemove: [],
                tagList: []
            }

            // Info
            user.info = this.employee
            user.info.organizationId = this.selectedCompanies[0].id
            user.info.username = this.employee.email

            // Active
            if (user.activeInOrganization !== this.enabled) {
                if (this.enabled) {
                    user.active = true
                } else {
                    user.active = false
                }
            }

            // Roles
            if (this.roleSelected === 'localadministrator') {
                user.roles.push({
                    systemNameList: ['admin_drive'],
                    filterGroupList: null,
                    applicationId: this.portalAppKey
                })
                let supplyTypes = []
                this.selectedMultipleSupplyType.forEach(supplyType => {
                    supplyTypes.push(supplyType.systemName)
                })
                user.roles.push({
                    systemNameList: ['caseowner'],
                    applicationId: this.application.key,
                    filterGroupList: supplyTypes
                })
                user.roles.push({
                    systemNameList: ['config'],
                    applicationId: this.application.key,
                    filterGroupList: null
                })
            } else {
                let supplyTypes = []
                if (this.roleSelected !== 'contractor') {
                    this.selectedMultipleSupplyType.forEach(supplyType => {
                        supplyTypes.push(supplyType.systemName)
                    })
                }
                user.roles.push({
                    systemNameList: [this.roleSelected],
                    filterGroupList: supplyTypes,
                    applicationId: this.application.key
                })
            }

            // Tags
            user.tagList = this.selectedTags

            // Permissions
            user.permissionEditGisData = this.permissionEditGisData

            user.usersAreAssociated = true

            user.automaticCloseTask = this.automaticCloseTask

            // Create or update user
            new Promise((resolve, reject) => {
                if (this.newUser && !this.newExistingUser) {
                    resolve(this.setCreateUser(user))
                } else {
                    user.rolesToRemove = this.currentUserRoles
                    resolve(this.setUpdateUser(user))
                }
            }).then(() => {
                this.updateAssociatedUsers({
                    userId: user.info.userId,
                    associatedUserIdList: this.selectedUsers ? this.selectedUsers.map(user => user.userId) : [],
                    associatedUserList: this.selectedUsers ? this.selectedUsers : [],
                    applicationId: this.portalAppKey
                })
                    .then((response) => {
                        this.selectedUsers = response
                        user.usersAreAssociated = true
                    })
            }).then(() => {
                const selectedFacilityTrees = this.facilityTrees.filter(item => item.selected)
                const unSelectedFacilityTrees = this.facilityTrees.filter(item => item.selected === false && item.userGroup.facilityUserGroupId)
                for (const unSelectedTree of unSelectedFacilityTrees) {
                    const params = { userId: user.info.userId, facilityTreeId: unSelectedTree.facilityTreeId }
                    this.removeUserFromFacilityUserGroup(params)
                }
                for (const selectedTree of selectedFacilityTrees) {
                    if (selectedTree.selectedUserGroupId !== selectedTree.userGroup.facilityUserGroupId) {
                        const params = {
                            userId: user.info.userId,
                            facilityTreeId: selectedTree.facilityTreeId,
                            facilityUserGroupId: selectedTree.selectedUserGroupId
                        }
                        this.addUserToFacilityUserGroup(params)
                    }
                }
            }).then(() => {
                this.closeModal()
            })
        },
        changeTab (selectedTab) {
            this.selectedTab = selectedTab
        },
        toggleTree (tree) {
            if (tree.selected && !tree.selectedUserGroupId) {
                tree.selectedUserGroupId = tree.userGroups[tree.userGroups.length - 1].facilityUserGroupId
            }
        }
    },
    created () {
        if (this.employee.userId) {
            const user = Object.assign({}, this.employee)

            this.automaticCloseTask = user.automaticCloseTask

            // Roles
            if (user.applicationGroupList) {
                this.currentUserRoles = user.applicationGroupIdList
                this.roleSelected = this.$filters.translateRoles(user.applicationGroupList, 'sys')
            }

            // SupplyTypes
            if (user.customKeyList && user.customKeyList.length > 0) {
                user.customKeyList.forEach(supplyType => {
                    this.setSelectedMultipleSupplyTypeFromId(supplyType)
                })
            } else {
                if (user.applicationGroupStr.toLowerCase() === 'contractor' && !user.customKeyList) {
                    this.supplyTypes.forEach(supplyType => {
                        this.setSelectedMultipleSupplyTypeFromId(supplyType.sysBusinessAreaTypeId)
                    })
                }
            }

            // Active or not
            this.enabled = user.activeInOrganization

            if (this.applicationSettings && this.applicationSettings.length === 0) {
                this.setApplicationSettingsDrive()
            }
            this.selectedTags = user.tagList
            this.permissionEditGisData = user.permissionEditGisData
            this.setAssociatedUsers({
                userId: user.userId,
                applicationId: this.portalAppKey
            })
                .then((response) => {
                    this.selectedUsers = response
                })
            this.setUserFacilityGroups(this.employee.userId).then((response) => {
                this.facilityTrees = response.userGroups
                this.setFacilityGroups().then((response) => {
                    this.facilityGroups = response.facilityUserGroups.sort((a, b) => a.systemName.localeCompare(b.systemName))
                    this.facilityTrees.forEach(tree => {
                        tree.userGroups = this.facilityGroups.map(group => ({ ...group }))
                        if (tree.userGroup && tree.userGroup.facilityUserGroupId) {
                            tree.selected = true
                            tree.selectedUserGroupId = tree.userGroup.facilityUserGroupId
                        }
                    })
                })
            })
            // })
        } else {
            this.newUser = true
        }
    }
}
</script>

<style lang="scss">
    .multiselect__tags {
        max-width: 460px;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/administration/drive/administration-modal-user-drive.vue